import { render, staticRenderFns } from "./home_doctor.vue?vue&type=template&id=15a61db6&scoped=true&"
import script from "./home_doctor.vue?vue&type=script&lang=js&"
export * from "./home_doctor.vue?vue&type=script&lang=js&"
import style0 from "./home_doctor.vue?vue&type=style&index=0&id=15a61db6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a61db6",
  null
  
)

export default component.exports